import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { TerminationCreate } from '../../modules/NewHire/components/TerminationCreate';
import { terminationDashboardCheck } from '../../tools/permissionChecks';

export const Route = createFileRoute('/hrDashboard/newFire/create')({
  component: RouteComponent,
  loader(ctx) {
    const permissionCheck = terminationDashboardCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to create terminations. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'HR Dashboard - Employee Termination' }],
    };
  },
});

function RouteComponent() {
  return <TerminationCreate />;
}
